import React from 'react'
import Img from "gatsby-image"

export const PostImage = (props: any) => {
    // const responsiveImage = JSON.parse(fluidimage)
    console.log('fluidimage', props)
    //...
    // return <Img fluid={fluidimage} />
    return (null)
}